(function() {
    'use strict';
    var AllegationCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, $http, xmsNotificationFactory) {
        console.log("Inside AllegationCtrl");
        console.log(passedModel)
        $scope.allegationModel = {};
        $scope.allegationModel.errorMessageVal = '';
        $scope.allegationModel.errorMessage = false;
        $scope.allegationModel.disableAddBtn = false;
        $scope.ngModel = passedModel;
        $scope.allegationModel.attachments = [];
        $scope.isVisible = [];
        $scope.isEditVisible = [];

        $scope.saveForm = function($event) {
            console.log($scope.allegationModel);
            $event.preventDefault();
            var isValid = this.allegationPopupForm.$valid;
            if(isValid){
                $scope.allegationModel.disableAddBtn = true;
                var data = $scope.allegationModel;
                var ajaxUrl = WEBAPP_PATH + "/safeguarding/saveAllegation";
                var fd = new FormData(),
                    c = 0,
                    file_data;
                $('input[type="file"]').each(function(){
                    file_data = $('input[type="file"]')[c].files; // for multiple files
                    // this is bad idea to use jQuery inside any Angular code
                    // please replace that with ng-model on your inputs, then you can access your data
                    for(var i = 0; i<file_data.length; i++){
                        fd.append("attachments_" + c, file_data[i]);
                    }
                    c++;
                });
                var ajaxData = $('#allegationPopupForm').serializeArray();
                $.each(ajaxData, function(key, input) {
                    fd.append(input.name, input.value);
                });
                $http({
                    method: "post",
                    url: ajaxUrl,
                    data: fd,
                    headers: {'Content-Type': undefined},
                    transformRequest: angular.identity
                }).then(function(response) {
                    if(response.data.success == true) {
                        xmsNotificationFactory.addObj({id: "allegationPopup", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout:10});
                        xmsNotificationFactory.bulk(response.data.attachmentErrors);
                        $uibModalInstance.close($scope.ngModel);
                        $scope.ngModel.smartTableRefreshCounter++;
                    }
                });
            }
        };

        $scope.updateForm = function($event) {
            console.log($scope.allegationModel);
            $event.preventDefault();
            var isValid = this.allegationPopupForm.$valid;
            if(isValid){
                $scope.allegationModel.disableAddBtn = true;
                var data = $scope.allegationModel;
                var ajaxUrl = WEBAPP_PATH + "/safeguarding/updateAllegation/" + $scope.allegationModel.id;
                //$scope.ajaxCallList(ajaxUrl , data);
                var fd = new FormData(),
                    c = 0,
                    file_data;
                $('input[type="file"]').each(function(){
                    file_data = $('input[type="file"]')[c].files; // for multiple files
                    // this is bad idea to use jQuery inside any Angular code
                    // please replace that with ng-model on your inputs, then you can access your data
                    for(var i = 0; i<file_data.length; i++){
                        fd.append("attachments_" + c, file_data[i]);
                    }
                    c++;
                });
                var ajaxData = $('#allegationPopupForm').serializeArray();
                $.each(ajaxData, function(key, input) {
                    fd.append(input.name, input.value);
                });
                $http({
                    method: "post",
                    url: ajaxUrl,
                    data: fd,
                    headers: {'Content-Type': undefined},
                    transformRequest: angular.identity
                }).then(function(response) {
                    if(response.data.success == true) {
                        xmsNotificationFactory.addObj({id: "allegationPopup", type: response.data.responseType, bodyHtml: response.data.responseMessage, timeout:10});
                        xmsNotificationFactory.bulk(response.data.attachmentErrors);
                        $uibModalInstance.close($scope.ngModel);
                        $scope.ngModel.smartTableRefreshCounter++;
                    }
                });
            }
        };

        $scope.ajaxCallList = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                $scope.allegationModel.disableAddBtn = false;
                $scope.allegationModel.successMsg="Success";
                $scope.ngModel.smartTableRefreshCounter++
                $uibModalInstance.close($scope.ngModel);
            }, function(result) {
                $scope.allegationModel.disableAddBtn = false;
                $scope.allegationModel.errorMessage = true;
                $scope.allegationModel.errorMessageVal = errorMsg;
            });
        };


        $scope.closePop = function($event) {
            $uibModalInstance.close($scope.ngModel);
        };

        $scope.cancel = function() {
            $uibModalInstance.close($scope.ngModel);
        };

        $scope.allegationDelete = function($event) {
            $event.preventDefault();
            var data = $scope.allegationModel;
            var ajaxUrl = WEBAPP_PATH + "/safeguarding/deleteAllegation/" + data.allegationId;
            $scope.ajaxCallList(ajaxUrl);
        };

        $scope.addAttachment = function($event) {
            $scope.allegationModel.attachments.push(new Date());
        };

        $scope.deleteAttachment = function(id, index, visibleList) {
            if(id == null) {
                visibleList[index] = true;
            } else {
                var url = WEBAPP_PATH + "/safeguarding/deleteAttachment/" + id;
                ajaxCall.getData(url).then(
                    function(result) {
                        console.log("/safeguarding/deleteAttachment/", result.data);
                        if (result.data.success == true) {
                            visibleList[index] = true;
                        }
                    },
                    function() {
                        console.log("Attachment delete error.");
                    }
                );
            }
        };
    }
    AllegationCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params' , '$http', 'xmsNotificationFactory'];
    angular.module('app').controller('AllegationCtrl', AllegationCtrl);
}());